import { AxiosAdapter as CoreAxiosAdapter } from '@core/adapters';
import { ROUTE_NAME } from '@infra/constants';
import { InternalAxiosRequestConfig } from 'axios';

export class AxiosAdapter extends CoreAxiosAdapter {
  async handle401Error(
    errorMessage: string,
    errorCode: string | number,
    errorData: any = null
  ) {
    console.error('401 Unauthorized Error =====');
    switch (errorCode) {
      case 'SIGNUP_AVAILABLE': {
        this.userStore.setUserInfoFromOAuth(errorData);
        break;
      }
      default: {
        console.warn(`Unhandled error code: ${errorCode}`);
        await this.alertStore.showAlertDialog(errorMessage);
        this.commonStore.clearAccessToken();
        await this.router.push({ name: ROUTE_NAME.SignIn });
        break;
      }
    }
  }

  // 골프장별 요청 헤더 설정
  handleRequest(
    config: InternalAxiosRequestConfig
  ): InternalAxiosRequestConfig {
    // 부모 클래스의 handleRequest 실행
    config = super.handleRequest(config);

    // 추가적인 ccType 헤더 설정
    const ccType = this.commonStore.ccType;
    if (config.headers) {
      config.headers.ccType = ccType;
    }
    return config;
  }
}
